import { STATES } from '@platform-shared/constants'
import _pick from 'lodash/pick'
import _omit from 'lodash/omit'
import { mapGetters, mapActions } from 'vuex'
import localizeMixin from '@platform-shared/mixins/localizeMixin'

export default {
  props: {
    surveyConfig: {
      type: Object,
      required: false,
      default: undefined,
    },
    healthActionId: {
      type: Number,
      required: true,
    },
    surveyId: {
      type: Number,
      required: true,
    },
    dependent: {
      type: Object,
      required: false,
      default: undefined,
    },
  },
  mixins: [localizeMixin],
  data() {
    return {
      source: '~/assets/survey.html',
      states: STATES.map((state) => {
        return { ...state, text: state.display }
      }),
      error: null,
    }
  },
  computed: {
    ...mapGetters('healthActions', ['isSubmittingSurvey']),
    dependentData() {
      return this.dependent
        ? _pick(this.dependent, ['memberId', 'memberCoverageId'])
        : null
    },
    formattedSurveyConfig() {
      return this.surveyConfig.config.pages ? this.surveyConfig : {}
    },
  },
  methods: {
    ...mapActions('healthActions', ['submitSurveyCompletion']),
    handleSubmit(payload) {
      this.error = null
      this.submitSurveyCompletion({
        surveyCompletion: {
          surveyData: _omit(payload, ['activityCompletionDate']),
          activityCompletionDate: payload.activityCompletionDate,
          dependent: this.dependentData,
        },
        healthActionId: this.healthActionId,
        surveyId: this.surveyId,
      })
        .then(() => this.$emit('complete'))
        .catch(() => (this.error = this.localize('common.failure')))
    },
  },
}
